import { directus } from "../Config/ApiUrls";
import { Api } from "../Config/Requests";
import { storage } from "../Config/Storage";


export const requestrfqs = async (data) => {
    const rfq = await Api.GetRequest(directus + `items/RFQs?fields[]=Status&fields[]=name&fields[]=file&fields[]=user_id&fields[]=id&filter[_and][0][user_id][_eq]=${data.id}&sort[]=-id&limit=5`)
    const countdata = await Api.GetRequest(directus + `items/RFQs?aggregate[countDistinct]=id&filter[_and][0][user_id][_eq]=${data.id}`);

    return { data: { data: { data: rfq?.data?.data, total: countdata?.data?.data[0]?.countDistinct?.id } } }

}

export const requestrfq = async (data) => {
    const save = await Api.PostRequest(directus + `files`, data)
    for (let [key, value] of data.entries()) {
        if (key === 'file') {
            storage.set.rfq(value.name)
        }
    }
    let payload = {
        file: save?.data?.data?.id,
        Status: "draft",
        name: storage.fetch.rfq()
    }
    const saved = await Api.PostRequest(directus + `items/RFQs`, payload)
    storage.set.rfqID(saved?.data?.data?.id)
    return saved

};
export const requestdeleterfq = async (data) => {

    return Api.DeleteRequest(directus + `items/RFQs/${data.id}`)
}


export const requestaddproducts = async (data, payload) => {
    const save = await Api.PostRequest(directus + `items/Orders`, data)

    let payload1 = []
    payload.map((item) => {
        payload1.push({
            attribute_value: item.attribute_value, attribute_name: item?.attribute_name, order_id: save?.data?.data?.id, status: "published"
        })
    })

    const order_prod = await Api.PostRequest(directus + `items/Order_products`, payload1)
    return save
};

export const requestupdaterfq = async (data) => {
    const rfq = storage.fetch.rfqID()
    const saved = await Api.PatchRequest(directus + `items/RFQs/${rfq}`, data)
    return saved

};

export const requestdeleteproducts = async (data) => {
    const orders = await Api.GetRequest(directus + `items/Order_products?limit=25&fields[]=attribute_name&fields[]=attribute_value&fields[]=order_id&fields[]=status&fields[]=id&sort[]=sort&page=1&filter[_and][0][_and][0][order_id][id][_eq]=${data.id}`)

    let order_prod_id = orders?.data?.data?.map((item) => {
        return item.id
    })
    const deleteorderdetails = await Api.DeleteRequest(directus + `items/Order_products`, order_prod_id)
    if (deleteorderdetails)
        return Api.DeleteRequest(directus + `items/Orders/${data.id}`)


};

export const requestdraftorders = async (data) => {
    // Fetch the initial orders
    const orderResponse = await Api.GetRequest(
        directus +
        `items/Orders?fields[]=product&fields[]=order_image&fields[]=unit&fields[]=product_name&fields[]=quantity&fields[]=status&fields[]=user_id&fields[]=id&sort[]=sort&page=1&filter[_and][0][session][_contains]=${data.session}&filter[_and][0][user_id][_null]:true`
    );

    const orders = orderResponse?.data?.data || [];

    // Use Promise.all to fetch details for each order
    const ordersWithDetails = await Promise.all(
        orders.map(async (item) => {
            const detailsResponse = await Api.GetRequest(
                directus +
                `items/Order_products?fields[]=attribute_value&filter[_and][0][_and][0][order_id][_eq]=${item.id}`
            );
            const details = detailsResponse?.data?.data || [];
            // Assign the details property to the item
            return { ...item, details };
        })
    );

    // Return the updated orders with details
    return { ...orderResponse, data: { ...orderResponse.data, data: ordersWithDetails } };
};

export const requestorders = async (data) => {
    // Fetch the initial orders

    let status = ''
    if (data?.status !== null && data?.status !== undefined) {
        status += `&filter[_and][0][status][_eq]=${data.status}`
    }
    const orderResponse = await Api.GetRequest(
        directus +
        `items/Orders?fields[]=product&fields[]=order_image&fields[]=unit&fields[]=product_name&fields[]=quantity&fields[]=status&fields[]=user_id&fields[]=id&sort[]=-id&page=${data.page}&limit=5&filter[_and][0][user_id][_eq]=${data.id}${status}`
    );
    const countdata = await Api.GetRequest(directus + `items/Orders?aggregate[countDistinct]=id&filter[_and][0][user_id][_eq]=${data.id}${status}`);

    const orders = orderResponse?.data?.data || [];

    // Use Promise.all to fetch details for each order
    const ordersWithDetails = await Promise.all(
        orders.map(async (item) => {
            const detailsResponse = await Api.GetRequest(
                directus +
                `items/Order_products?fields[]=attribute_name&fields[]=attribute_value&filter[_and][0][_and][0][order_id][_eq]=${item.id}`
            );
            const details = detailsResponse?.data?.data || [];

            const status = item.status && await Api.GetRequest(directus + `items/Status/${item.status}`);
            const statusname = status?.data?.data?.name || [];
            // Assign the details property to the item
            return { ...item, details, statusname };
        })
    );

    // Return the updated orders with details
    return { ...orderResponse, data: { ...orderResponse.data, data: { data: ordersWithDetails, total: countdata?.data?.data[0]?.countDistinct?.id } } };
};
export const requestordersDetails = async (data) => {
    const details = await Api.GetRequest(directus + `items/Order_products?fields[]=attribute_name&fields[]=attribute_value&fields[]=id&sort[]=sort&page=1&filter[_and][0][_and][0][order_id][_eq]=${data.id}`)
    const order = await Api.GetRequest(directus + `items/Orders/${data.id}`)
    return { ...order.data.data, details: details.data.data }
}


export const requestupdateOrder = async (data) => {
    if (data.payload !== '') {
        data?.payload?.map(async (item) => {
            const updateDetails = await Api.PatchRequest(directus + `items/Order_products/${item?.id}`, item)
        })
    }
    return Api.PatchRequest(directus + `items/Orders/${data.data.id}`, data.data)
}

export const requestStatus = async (data) => {
    return Api.GetRequest(directus + `items/Status`)
}


// Define All User APIs
const MycartApiRequests = {
    requestrfqs,
    requestrfq,
    requestupdaterfq,
    requestaddproducts,
    requestdeleteproducts,
    requestdraftorders,
    requestorders,
    requestordersDetails,
    requestupdateOrder,
    requestdeleterfq,
    requestStatus
};
export default MycartApiRequests;